// extracted by mini-css-extract-plugin
export var askAiIcon = "_ne-9";
export var container = "_ne-0";
export var groupSeparator = "_ne-a";
export var highlight = "_ne-4";
export var resultIcon = "_ne-5";
export var resultItem = "_ne-7";
export var resultSubtitle = "_ne-3";
export var resultTitle = "_ne-2";
export var resultsList = "_ne-1";
export var searchGroup = "_ne-6";
export var selected = "_ne-8";